//回放支持的绘制类型
export const CanvasType = {
    TEXT: "text",
    LINE: "line",
    PENCIL: "pencil",
    RECTANGLE: "rectangle",
}

//白板支持的操作类型
export const operation_321 = 321; //白板绘制
export const operation_323 = 323; //撤销（undo）把已经绘制的，撤销，保存到撤销的数组中
export const operation_324 = 324; //重做（redo），从撤销的数组中取出第一个重新绘制
export const operation_325 = 325; //清空（clear），清空画布
export const operation_326 = 326; //橡皮擦,删除指定一笔（shapeId）
export const operation_327 = 327; //移动绘制对象,仅针对文字移动

export const operation_258 = 258; //翻页
export const operation_260 = 260; //创建白板
export const operation_288 = 288; //获取全部课件\

export const message_type_image = 386; //聊天图片
export const message_type_txt = 385; //聊天文字

export const emojiUrl = "https://cdn.jsdelivr.net/npm/twemoji@11.3.0/2/svg/";

export const recordApi = 'https://record.olacio.com';
export const OLD_VIDEO_URL_PREFIEX = 'https://record.olacio.com/record/data/video/';

export const MAX_AUDIO_PLAY_OFFSET = 0.2;
export const MAX_VIDEO_PLAY_OFFSET = 0.1;